import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IWriteUp } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class WriteUpService extends BaseService<IWriteUp> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'writeUp');
  }
}

export { IWriteUp } from '../shared/api';
